import axios from "axios";


const api = axios.create({
  responseType: "json",
  baseURL: "/public/payment-robokassa-service/api/v1",
  headers: {
    "Content-Type": "application/json"
  }
});

class RobokassaApi {
  static async getOrderByInvoiceNumber(invoice) {
    
    const result = await api
      .get(`/payments/${invoice}`)
      .then(response => {
        return { status: response.status, data: response.data };
      })
      .catch(error => {
        if (error.response === undefined) {
          // on network error
          return { status: 1001, data: null };
        } else {
          // on other errors
          return { status: error.response.status, data: null };
        }
      });
    
    return result;
  }
}

export {
  RobokassaApi,
}
